import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ng-core-modal',
  styleUrls: ['./modal.component.scss'],
  providers: [BsModalService],
  template: `
    <ng-template #rootRef>
      <div class="modal-header no-border" *ngIf="openedModalRef">
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span></button>
        <h3 class="modal-title" *ngIf="title">{{ title }}</h3>
      </div>
      <div class="modal-body">
        <ng-content></ng-content>
      </div>
    </ng-template>
  `
})
export class ModalCoreComponent {

  @ViewChild('rootRef') rootRef;
  @Input() title: string;
  @Input() config: any = {};
  @Output() close = new EventEmitter();

  subscriptions: Subscription[] = [];
  openedModalRef: BsModalRef;

  constructor(private modalService: BsModalService) {}

  openModal() {
    this.openedModalRef = this.modalService.show(this.rootRef, this.config);
    this.triggerEvents();
  }

  closeModal() {
   this.openedModalRef.hide();
  }

  triggerEvents() {
    this.subscriptions.push(
      this.modalService.onHidden.subscribe(() => {
        this.close.emit();
        this.unsubscribe();
      })
    );
  }

  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }

}
